// 16 Emotional Tags for Movie Mood Discovery
export const EMOTIONS = [
  { id: 'energized', label: 'Energized', icon: '⚡', description: 'Pumped up, ready to conquer' },
  { id: 'inspired', label: 'Inspired', icon: '🔥', description: 'Motivated to be better' },
  { id: 'empowered', label: 'Empowered', icon: '💪', description: 'Confident and strong' },
  { id: 'heartwarmed', label: 'Heartwarmed', icon: '🥰', description: 'Faith in humanity' },
  { id: 'hopeful', label: 'Hopeful', icon: '🌟', description: 'Optimistic about life' },
  { id: 'romantic', label: 'Romantic', icon: '💕', description: 'In love, butterflies' },
  { id: 'cozy', label: 'Cozy', icon: '🏠', description: 'Comforted, nostalgic' },
  { id: 'peaceful', label: 'Peaceful', icon: '🧘', description: 'Calm and serene' },
  { id: 'mindblown', label: 'Mind-blown', icon: '🤯', description: "Can't stop thinking" },
  { id: 'thoughtful', label: 'Thoughtful', icon: '🧠', description: 'Reflective, philosophical' },
  { id: 'joyful', label: 'Joyful', icon: '😂', description: 'Laughing, pure happiness' },
  { id: 'thrilled', label: 'Thrilled', icon: '🎢', description: 'Edge of seat excitement' },
  { id: 'moved', label: 'Moved', icon: '😢', description: 'Cried, emotionally touched' },
  { id: 'firedup', label: 'Fired Up', icon: '😤', description: 'Angry, want to change things' },
  { id: 'scared', label: 'Scared', icon: '😱', description: 'Terrified, unsettled' },
  { id: 'awestruck', label: 'Awestruck', icon: '🌌', description: 'Wonder and transcendence' },
] as const;

export type EmotionId = typeof EMOTIONS[number]['id'];

// Genre ID → Emotion mapping (for seed data generation - Phase B)
// TMDB Genre IDs
export const GENRE_EMOTION_MAP: Record<number, { emotion: EmotionId; confidence: number }[]> = {
  28:    [{ emotion: 'energized', confidence: 0.8 }, { emotion: 'thrilled', confidence: 0.7 }],     // Action
  12:    [{ emotion: 'awestruck', confidence: 0.7 }, { emotion: 'energized', confidence: 0.6 }],   // Adventure
  16:    [{ emotion: 'joyful', confidence: 0.6 }, { emotion: 'heartwarmed', confidence: 0.5 }],    // Animation
  35:    [{ emotion: 'joyful', confidence: 0.9 }, { emotion: 'heartwarmed', confidence: 0.4 }],    // Comedy
  80:    [{ emotion: 'thrilled', confidence: 0.7 }, { emotion: 'thoughtful', confidence: 0.5 }],   // Crime
  99:    [{ emotion: 'thoughtful', confidence: 0.7 }, { emotion: 'mindblown', confidence: 0.5 }],  // Documentary
  18:    [{ emotion: 'moved', confidence: 0.7 }, { emotion: 'thoughtful', confidence: 0.6 }],      // Drama
  10751: [{ emotion: 'heartwarmed', confidence: 0.8 }, { emotion: 'cozy', confidence: 0.7 }],      // Family
  14:    [{ emotion: 'awestruck', confidence: 0.8 }, { emotion: 'cozy', confidence: 0.5 }],        // Fantasy
  36:    [{ emotion: 'thoughtful', confidence: 0.6 }, { emotion: 'moved', confidence: 0.5 }],      // History
  27:    [{ emotion: 'scared', confidence: 0.9 }, { emotion: 'thrilled', confidence: 0.6 }],       // Horror
  10402: [{ emotion: 'joyful', confidence: 0.7 }, { emotion: 'energized', confidence: 0.5 }],      // Music
  9648:  [{ emotion: 'mindblown', confidence: 0.7 }, { emotion: 'thrilled', confidence: 0.6 }],    // Mystery
  10749: [{ emotion: 'romantic', confidence: 0.9 }, { emotion: 'heartwarmed', confidence: 0.6 }],  // Romance
  878:   [{ emotion: 'mindblown', confidence: 0.8 }, { emotion: 'awestruck', confidence: 0.7 }],   // Sci-Fi
  53:    [{ emotion: 'thrilled', confidence: 0.9 }, { emotion: 'scared', confidence: 0.4 }],       // Thriller
  10752: [{ emotion: 'moved', confidence: 0.7 }, { emotion: 'firedup', confidence: 0.6 }],         // War
  37:    [{ emotion: 'energized', confidence: 0.5 }, { emotion: 'awestruck', confidence: 0.4 }],   // Western
};

// Movie genres for onboarding (subset of most popular)
export const ONBOARDING_GENRES = [
  { id: 28, name: 'Action', icon: '💥' },
  { id: 12, name: 'Adventure', icon: '🗺️' },
  { id: 16, name: 'Animation', icon: '🎨' },
  { id: 35, name: 'Comedy', icon: '😂' },
  { id: 80, name: 'Crime', icon: '🔪' },
  { id: 99, name: 'Documentary', icon: '📹' },
  { id: 18, name: 'Drama', icon: '🎭' },
  { id: 10751, name: 'Family', icon: '👨‍👩‍👧‍👦' },
  { id: 14, name: 'Fantasy', icon: '🧙' },
  { id: 36, name: 'History', icon: '📜' },
  { id: 27, name: 'Horror', icon: '👻' },
  { id: 10402, name: 'Music', icon: '🎵' },
  { id: 9648, name: 'Mystery', icon: '🔍' },
  { id: 10749, name: 'Romance', icon: '💕' },
  { id: 878, name: 'Sci-Fi', icon: '🚀' },
  { id: 53, name: 'Thriller', icon: '😰' },
  { id: 10752, name: 'War', icon: '⚔️' },
  { id: 37, name: 'Western', icon: '🤠' },
];
